import { Link } from "@tanstack/react-router";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { company } from "@/data/site";

export function CTABlock({
  title = "Ready for a free, no-pressure quote?",
  subtitle = "Tell us what needs cleaning. We usually respond same day, often within an hour.",
}: { title?: string; subtitle?: string }) {
  return (
    <section className="bg-background">
      <div className="mx-auto max-w-4xl px-4 py-16 text-center sm:px-6 lg:px-8">
        <h2 className="text-3xl font-extrabold text-primary sm:text-4xl text-balance">{title}</h2>
        <p className="mx-auto mt-3 max-w-2xl text-foreground/80">{subtitle}</p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button asChild size="lg" className="btn-glow bg-primary text-primary-foreground hover:bg-primary/90 shadow-glow">
            <Link to="/contact">Get a Free Quote</Link>
          </Button>
          <Button asChild size="lg" className="btn-glow bg-accent text-accent-foreground hover:bg-accent/90 shadow-glow">
            <Link to="/contact">
              <Phone className="mr-2 h-4 w-4" />
              {company.phone}
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
